import React, { memo, useCallback } from 'react';
import { areEqual } from 'Utils/equalityChecks';

import { MoistureLogsTable } from 'Components/RocketDry';

import { moistureLogTableHeaders } from 'Utils/table';

import { useRocketDryFunctions } from 'Context/RocketDry';

interface Props {
  materialWithLogs: any;
  roomId: number;
  handleViewPicture: (e: any) => void;
}

function MoistureLogsTableContainer({ materialWithLogs, roomId, handleViewPicture }: Props) {
  const { logs, materialName } = materialWithLogs;

  const {
    setIsAddMoistureLogReadingModalOpen,
    setIsEditMoistureLogReadingModalOpen,
    setIsDeleteMoistureLogModalOpen,
    setSelectedDamageMaterial,
    setSelectedRoomId,
    setSelectedMoistureLog,
  }: any = useRocketDryFunctions();

  const handleAddLog = useCallback(() => {
    setIsAddMoistureLogReadingModalOpen(true);
    setSelectedDamageMaterial({
      materialId: materialWithLogs.materialId,
      materialName: materialWithLogs.materialName,
      materialType: materialWithLogs.materialType,
    });
    setSelectedRoomId(roomId);
  }, [roomId]);

  const handleEditLog = useCallback(
    (log: any) => {
      setIsEditMoistureLogReadingModalOpen(true);
      setSelectedMoistureLog(log);
      setSelectedRoomId(roomId);
    },
    [roomId]
  );

  const handleDeleteLog = useCallback(
    (log: any) => {
      setIsDeleteMoistureLogModalOpen(true);
      setSelectedDamageMaterial({
        materialId: materialWithLogs.materialId,
        materialName: materialWithLogs.materialName,
        materialType: materialWithLogs.materialType,
      });
      setSelectedMoistureLog(log);
      setSelectedRoomId(roomId);
    },
    [roomId]
  );

  return (
    <MoistureLogsTable
      headers={moistureLogTableHeaders}
      logs={logs}
      materialName={materialName}
      handleViewPicture={handleViewPicture}
      handleAddLog={handleAddLog}
      handleEditLog={handleEditLog}
      handleDeleteLog={handleDeleteLog}
    />
  );
}

const MoistureLogsTableContainerMemo = memo(MoistureLogsTableContainer, areEqual);

export { MoistureLogsTableContainerMemo as MoistureLogsTableContainer };
